document.addEventListener('DOMContentLoaded', () => {

  // Mobile $breakpoint-lg.
  if (window.innerWidth > 992) {
    return;
  }

  document.querySelectorAll('.views-exposed-form details').forEach((details) => {
    details.open = false;
  });
})
